// extracted by mini-css-extract-plugin
module.exports = {"noContentWrapper":"recent-page_noContentWrapper__29g77","title":"recent-page_title__2phkx","description":"recent-page_description__5dfkV"};